import { render, staticRenderFns } from "./CampaignMailQueue.vue?vue&type=template&id=7338ca57&"
import script from "./CampaignMailQueue.vue?vue&type=script&lang=js&"
export * from "./CampaignMailQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports